import {
  DebitOrderMandateServiceApiFactory,
  type ModelDebitOrderMandateCreateRequest,
  type ModelDebitOrderMandateResponse,
} from '@layup/api-sdk';
import { createLayupClient } from './layupApi';

export const debitOrderServiceClient = () => {
  const client = createLayupClient();
  return DebitOrderMandateServiceApiFactory(undefined, undefined, client);
};

export const initiateDebitOrder = async (
  payload: ModelDebitOrderMandateCreateRequest,
): Promise<ModelDebitOrderMandateResponse> => {
  const response = await debitOrderServiceClient().debitOrderMandateServiceCreate({
    modelDebitOrderMandateCreateRequest: payload,
  });
  return response.data;
};

export const getDebitOrderMandate = async (merchantId: string): Promise<ModelDebitOrderMandateResponse> => {
  const response = await debitOrderServiceClient().debitOrderMandateServiceGet({ merchantId });
  return response.data;
};
